var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNavegaciNContratos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.358 15.765c-.617 1.544-2.078 2.552-3.698 2.552H13.13c-1.202.985-2.956.904-4.068-.242l-2.966-3.057h-2.9v3.299H0v-1.65h1.598V4.303H0V2.653h3.198l-.001 1.654h2.76L14.594 0l4.139 4.306 2.06-.007V2.653H24v1.65h-1.606v12.365H24v1.649h-3.206l-.001-4.127h-1.806zM6.992 11.49c-.569.587-.569 1.532-.003 2.115l3.205 3.304c.571.589 1.498.589 2.069 0 .57-.59.569-1.542-.002-2.129l-3.2-3.288c-.571-.587-1.496-.588-2.069-.002zM5.638 5.957l-2.441-.001v7.412H5.07c-.274-1.05-.011-2.217.788-3.04 1.204-1.234 3.137-1.232 4.333-.004l3.2 3.288c.805.827 1.07 2 .794 3.056h.475c.972 0 1.848-.605 2.219-1.532l.643-1.611-4.28-6.046-3.503.552c-1.665.262-3.296-.579-4.1-2.074zm8.624-3.96L7.255 5.494c.526.683 1.376 1.043 2.242.907l4.465-.702 4.845 6.843h1.986V5.948l-2.726.01-3.805-3.96z",
    transform: "translate(-901 -485) translate(901 485) translate(0 2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavegaciNContratos);
export default __webpack_public_path__ + "static/media/icons-navegaci-n-contratos.af720f4a.svg";
export { ForwardRef as ReactComponent };